// Remembers the most recently opened book so the app's root (`/`) can jump
// straight back into reading. The library lives at `/library`; the Reader's
// back arrow points there, so this never causes a redirect loop.
const KEY = "tf_last_book";

export function getLastBook(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setLastBook(slug: string): void {
  try {
    localStorage.setItem(KEY, slug);
  } catch {
    /* storage unavailable (private mode / quota); reading still works */
  }
}

export function clearLastBook(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
